// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"520ce169","213":"fd6eaa0d","453":"c2476276","732":"032aeb29"}[chunkId] + ".chunk.js";
};